export default __webpack_public_path__ + "static/media/Regular tree.4c8dec13.png";